module.exports = "/images/protected-1-year-agent.png?1de5181b96aa3b82ede59317ad0622e1";